<div class="pin-dialog">
  <div class="pin-dialog__header">
    <img
      src="assets/icon/{{ isComplete ? 'pin-illustration.svg' : 'pin-successfull.svg' }}"
      alt="pin-illustration"
      width="150px"
    />
    <h2 class="pin-dialog__title">{{ title() }}</h2>
    <p class="pin-dialog__subtitle">{{ subtitle() }}</p>
  </div>

  @if (!isComplete) {
    <div class="pin-dialog__content">
      <div class="pin-input-container">
        <code-input
          #codeInput
          [codeLength]="6"
          [isCodeHidden]="true"
          [isCharsCode]="false"
          [isPrevFocusableAfterClearing]="true"
          [isFocusingOnLastByClickIfFilled]="true"
          (codeChanged)="onCodeChanged($event)"
          class="pin-input"
          [ngClass]="{ error: formInputShouldError() }"
        ></code-input>
      </div>

      @if (errorMessage(); as err) {
        <div class="error-message">
          {{ err }}
        </div>
      }
    </div>

    <div class="pin-dialog__actions">
      <lib-button
        type="Secondary"
        [disabled]="isLoading()"
        (onClick)="cancel()"
        label="Cancel"
        width="120px"
      >
      </lib-button>

      <lib-button
        type="Primary"
        [disabled]="!canProceed() || isLoading()"
        (onClick)="proceed()"
        width="120px"
        [label]="actionButtonText()"
      >
      </lib-button>
    </div>
  } @else {
    <div class="pin-dialog__actions">
      <lib-button type="Primary" (onClick)="handleSuccess()" label="Close" width="120px">
      </lib-button>
    </div>
  }
</div>

@if (isLoading()) {
  <app-block-loading></app-block-loading>
}
